module.exports = __webpack_public_path__ + "img/EASTASIA_FERMENTED_MILK.edc1c527.png";